import { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MetaTags from '../components/MetaTags';
import api from '../api/axios';
import './new-pages.css';

const PLACEHOLDER_EXCOM = [
  { id: 1, name: 'TBA', role: 'President', photo_url: null, facebook_url: null, term: '' },
  { id: 2, name: 'TBA', role: 'Vice President', photo_url: null, facebook_url: null, term: '' },
  { id: 3, name: 'TBA', role: 'Secretary', photo_url: null, facebook_url: null, term: '' },
  { id: 4, name: 'TBA', role: 'Treasurer', photo_url: null, facebook_url: null, term: '' },
];

function MemberCard({ m, large }) {
  const photoSize = large ? 180 : 140;
  return (
    <div className="committee-card">
      <div className="committee-photo" style={{ width: photoSize, height: photoSize }}>
        {m.photo_url
          ? <img src={m.photo_url} alt={m.name} />
          : <i className="fas fa-user"></i>
        }
      </div>
      <h4>{m.name}</h4>
      <p className="role">{m.role}</p>
      {m.term && <p className="term">{m.term}</p>}
      {m.facebook_url && (
        <a href={m.facebook_url} className="facebook-link" target="_blank" rel="noreferrer">
          <i className="fab fa-facebook-f"></i>
        </a>
      )}
    </div>
  );
}

export default function CommitteePage() {
  const [site, setSite] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [members, setMembers] = useState([]);
  const [membersLoading, setMembersLoading] = useState(true);

  useEffect(() => {
    fetch('/content.json')
      .then(r => r.json())
      .then(d => { setSite(d.site); setPageLoading(false); })
      .catch(() => setPageLoading(false));

    api.get('/committee').then(r => setMembers(r.data || [])).catch(() => {}).finally(() => setMembersLoading(false));
  }, []);

  const active = members.filter(m => m.is_active !== 0);
  const excom = active.slice(0, 4);
  const general = active.slice(4);
  const displayExcom = excom.length > 0 ? excom : PLACEHOLDER_EXCOM;

  if (pageLoading) return <div className="page-loading"><div className="spinner-ring"></div></div>;
  if (!site) return null;

  return (
    <div className="App">
      <MetaTags
        title="Committee | Melbourne Nepalese Community West"
        description="Meet the MNCW executive committee members who lead and serve our community."
        url="https://mncw.org.au/committee"
        image="https://mncw.org.au/assets/img/logo.jpg"
        type="website"
      />
      <Header data={site} />

      <div className="committee-page-container">
        <div className="container">
          {/* Executive Committee */}
          <div className="page-header">
            <span className="page-subtitle">Leadership</span>
            <h1>Executive Committee</h1>
          </div>

          {membersLoading ? (
            <div className="page-loading" style={{ padding: '40px 0' }}><div className="spinner-ring"></div></div>
          ) : (
            <div className="committee-grid" style={{ justifyContent: 'center' }}>
              {displayExcom.map(m => <MemberCard key={m.id} m={m} large={true} />)}
            </div>
          )}

          {/* General committee */}
          {general.length > 0 && (
            <>
              <div className="section-divider" style={{ marginTop: 64 }}>
                <h2>General Committee</h2>
              </div>
              <div className="committee-grid">
                {general.map(m => <MemberCard key={m.id} m={m} large={false} />)}
              </div>
            </>
          )}
        </div>
      </div>

      <Footer data={site} />
    </div>
  );
}
